import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: 0,
};

export const refreshDataSlice = createSlice({
  name: "refreshData",
  initialState,
  reducers: {
    setRefreshData: (state) => {
      state.value += 1;
      return state;
    },
  },
});

export const { setRefreshData } = refreshDataSlice.actions;

export default refreshDataSlice.reducer;
